<template>
    <div class='vx-col w-full mt-4'>
        <section class="ancho-juego">
            <vs-alert v-if="datos_editar.estado == 0" color="danger">{{ txt_juego_inactivo }} </vs-alert>
            <!-- <vs-button class="m-1" color="warning" icon="refresh" @click="f_reiniciar()">Reiniciar</vs-button> -->
            <div class="juego">
                <vs-row class="vx-row header m-4">
                    <vs-col class="w-4/5">
                        <div class="datos-juego-cabecera">
                            <div class="datos-header-cabecera text-center m-2 p-4">
                                <h3 class="titulo-juego"> {{ datos_juego.titulo }}</h3>
                                <h5 class="subtitulo-juego"> {{ datos_juego.descripcion }} </h5>
                            </div>
                            <div class="ancho-auto p-2 inline-block">
                                <Voces :datosVoz="datosVoz" />
                            </div>
                            <div class="ancho-auto p-2 inline-block" v-if="conReloj">
                                <Reloj :conReloj="conReloj" :game_fin="game_fin" />
                            </div>
                        </div>
                    </vs-col>
                    <vs-col class="w-1/5 mt-4">
                        <div class="calificacion text-color-2 mt-2">
                            <transition name="bounce">
                                <div v-if="datos_juego.correctas>0">
                                    {{datos_juego.correctas.toFixed(2)}} &nbsp;
                                </div>
                                <div v-else> 0 &nbsp; </div>
                            </transition>/ {{ datos_juego.puntaje }}
                        </div>
                    </vs-col>
                </vs-row>
                <div class="cards-grupo p-4 flex flex-row flex-wrap align-items-center">
                    <div v-for="(card, index) in cards" :key="index" class="card-container borde animar-carta" :class="['card', { flipped: card.flipped || card.matched }]" @click="flipCard(index)">
                        <img class="front" :src="$data_book+'archivos/'+card.src" alt="Editorial AZ" />
                        <figcaption v-if="!card.flipped" class="numero-carta back"> {{ index+1 }}</figcaption>
                        <img class="back" :src="coverImage" alt="Editorial AZ" />
                    </div>
                </div>
                <div class="espacio-inferior"></div>
            </div>
        </section>
    </div>
    </template>
    
    <script>
    import GeneralMixin from '@/mixins/GeneralMixin';
    import Voces from '../componentes/voces.vue';
    import Reloj from '../componentes/reloj.vue';
    export default {
        mixins: [GeneralMixin],
        props: {
            datos_editar: {
                type: Object,
                default: function () {
                    return {};
                },
            },
            juego_seleccionado: {
                type: Object,
                default: function () {
                    return {};
                },
            }
        },
        components: {
            Voces,
            Reloj
        },
        data() {
            return {
                cards: [],
                flippedCards: [],
                coverImage: '',
                id_juego: 0,
                datos_juego: {},
                datosVoz: {},
                conReloj: false,
                game_fin: false,
                txt_juego_inactivo: 'Juego inactivo - no será visible para el estudiante',
                suma_correctas: 0,
                arrayImagenes: [],
                codigo_juego: '',
                ArrayListadoFiles:[],
                idJuego:'',
            };
        },
        created() {
            let me = this 
            me.idJuego = localStorage.idJuego
        },
        mounted() {
            let me = this;
            me.getListadoFiles()
            me.comenzar()
        },
        methods: {
            comenzar(){
                let me = this
                const game_select = Object.keys(me.juego_seleccionado).length == 0
                // console.log('game select', game_select,me.juego_seleccionado)
                if (game_select) {
                    this.f_inicio();
                } else {
                    me.f_obtener_datos_juego();
                }
            },
            getListadoFiles(){
                let me = this
                me.$vs.loading();
                this.$http.get(this.$server_url+`juegosMetodosGet?getFilesJuegos=1&id_juego=${me.idJuego}`)
                    .then(function (res) {
                        let datos = res.data 
                        let array1 = res.data
                        let array2 = res.data
                        let resultado = array2.concat(array1)
                        resultado.forEach((element,index) => {
                            var cal = new Object()
                            cal.id      = index
                            cal.src     = 'memoria/'+element.url
                            cal.flipped = false
                            cal.matched = false
                            me.ArrayListadoFiles.push(cal)
                        });
                        me.$vs.loading.close()
                    })
                    .catch(function (error) {
                        console.log(error + ' error');
                        me.$vs.loading.close()
                    })
            },
            f_obtener_datos_juego() {
                let me = this;
                me.$vs.loading();
                me.$http.get(this.$server_url + 'get_juego_by_codigo/' + me.juego_seleccionado.codigo)
                    .then(function (response) {
                        // console.log(response.data);
                        me.datos_editar = response.data[0];
                        me.f_inicio();
                        me.$vs.loading.close();
                    })
                    .catch(function () {
                        me.f_notificaciones("No se encontró el juego.", "danger");
                        me.$vs.loading.close();
                        // me.$vs.loading.close();
                    })
            },
            f_reiniciar() {
                let me = this;
                me.f_inicio();
            },
            f_inicio() {
                let me = this;
                // console.log('this.juego_seleccionado',this.juego_seleccionado, me.datos_editar)
                me.datosVoz = me.datos_editar
                me.id_juego = me.datos_editar.id;
                me.arrayImagenes = [];
                // console.log('datos editar en previsualizar', me.datos_editar, me.id_juego)
                if (me.datos_editar.tiempo == 1) me.conReloj = true;
                me.datos_juego = {
                    puntaje: me.datos_editar.puntaje,
                    correctas: 0,
                    division_puntaje: 0,
                    titulo: me.datos_editar.nombre,
                    descripcion: me.datos_editar.descripcion,
                    total_correctas: 0,
                    suma_correctas: 0,
                }
                me.obtenerImagenes();
                me.initializeGame();
            },
            obtenerImagenes() {
                let me = this;
               /* for (let i = 1; i < 10; i++) {
                    me.arrayImagenes.push(`${i}.jpg`);
                }*/
                me.arrayImagenes = me.ArrayListadoFiles
            },
            initializeGame() {
                let me = this;
                //me.arrayImagenes.sort((a, b) => a - b);
                // console.log(me.arrayImagenes)           
                /*const cards = me.arrayImagenes.concat(me.arrayImagenes).map((src) => ({
                    src: require(`./assets/animales-salvajes/${src}`),
                    flipped: false,
                    matched: false,
                }));*/
                const cards = me.arrayImagenes
                //imagen q cubre las cartas
                me.coverImage = require('./assets/cover.jpg'),
                    this.cards = this.shuffle(cards);
                me.datos_juego.division_puntaje = me.datos_juego.puntaje / me.arrayImagenes.length
                me.datos_juego.total_correctas = me.arrayImagenes.length
            },
            shuffle(array) {
                for (let i = array.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [array[i], array[j]] = [array[j], array[i]];
                }
                return array;
            },
            flipCard(index) {
                const card = this.cards[index];
                if (!card.flipped && !card.matched) {
                    card.flipped = true;
                    this.flippedCards.push(index);
                    if (this.flippedCards.length === 2) {
                        this.checkMatch();
                    }
                }
            },
            checkMatch() {
                let me = this;
                const [index1, index2] = this.flippedCards;
                if (this.cards[index1].src === this.cards[index2].src) {
                    this.cards[index1].matched = true;
                    this.cards[index2].matched = true;
                    me.datos_juego.correctas += parseFloat(me.datos_juego.division_puntaje.toFixed(2));
                    me.datos_juego.suma_correctas++;
                } else {
                    setTimeout(() => {
                        this.cards[index1].flipped = false;
                        this.cards[index2].flipped = false;
                    }, 1000);
                }
                this.flippedCards = [];
                if (me.datos_juego.suma_correctas == me.datos_juego.total_correctas) {
                    me.game_fin = true;
                }
            },
    
        }
    };
    </script>
    
    <style lang="css" scoped>
    .ancho-juego {
        max-width: 80%;
        min-width: 600px;
        margin: 0 auto;
    }
    
    .juego {
        background-image: url('./assets/bg-memoria.jpg');
        background-repeat: no-repeat;
        background-size: cover;
        background-position: bottom center;
    }
    
    .datos-header-cabecera {
        background-color: #c6e2ee;
        border-radius: 20px;
    }
    
    .titulo-juego {
        /* font-family: "Teko", sans-serif; */
        /* color: white; */
        font-optical-sizing: auto;
        font-weight: 800;
        font-style: normal;
        font-size: 2.5em;
        font-family: "LXGW WenKai Mono TC", monospace;
    }
    
    .cards-grupo {
        width: 80%;
        margin: 0 auto;
        justify-content: center;
        /* animation-name: fadeInOut, moveLeft300px, bounce;
    animation-duration: 1s, 1s;
    animation-iteration-count: 2, 1; */
        animation-duration: 2s;
        animation-name: slidein;
    }
    
    .card-container {
        perspective: 1000px;
        cursor: pointer;
        box-shadow: rgb(38, 57, 77) 0px 20px 30px -10px;
    }
    
    .card {
        width: 140px;
        height: 140px;
        position: relative;
        transform-style: preserve-3d;
        transition: transform 0.8s;
        margin: 5px;
    
    }
    
    .borde {
        border: solid 3px #dddddd;
        border-radius: 10px;
        padding: 10px;
    }
    
    .card.flipped {
        transform: rotateY(180deg);
    }
    
    .card img {
        width: 100%;
        height: 100%;
        backface-visibility: hidden;
        position: absolute;
        top: 0;
        left: 0;
        padding: 4px;
    }
    
    .card .front {
        background-color: white;
        transform: rotateY(180deg);
        content: 'transform';
    }
    
    .espacio-inferior {
        height: 80px;
    }
    
    .numero-carta {
        /* font-size: 1em; */
        /* font-weight: bold; */
        z-index: 99;
        position: absolute;
        /* background-color: rgb(185, 238, 222); */
        background-color: orangered;
        color: white;
        border-radius: 50%;
        padding: 2px 4px;
        bottom: 10px;
        right: 15px;
    }
    
    @media only screen and (max-width: 820px) {
        .ancho-juego {
            width: 100%;
            margin: 0 auto;
            min-width: 600px;
    
        }
    
        .juego {
            background-image: url('./assets/bg-memoria.jpg');
            background-repeat: no-repeat;
            background-size: cover;
            background-position: bottom center;
        }
    
        .cards-grupo {
            width: 100%;
            margin: 0 auto;
            justify-content: center;
    
        }
    }
    
    @keyframes shake3856 {
        0% {
            -webkit-transform: translate(0);
            transform: translate(0);
        }
    
        20% {
            -webkit-transform: translate(-2px, 2px);
            transform: translate(-2px, 2px);
        }
    
        40% {
            -webkit-transform: translate(-2px, -2px);
            transform: translate(-2px, -2px);
        }
    
        60% {
            -webkit-transform: translate(2px, 2px);
            transform: translate(2px, 2px);
        }
    
        80% {
            -webkit-transform: translate(2px, -2px);
            transform: translate(2px, -2px);
        }
    
        100% {
            -webkit-transform: translate(0);
            transform: translate(0);
        }
    }
    
    @keyframes slidein {
        0% {
            /* translate: -100vw 0; */
            translate: 0 200px;
            opacity: 0.1;
            /* scale: 150% 1; */
        }
    
        30% {
            /* translate: -80vw 0; */
            translate: 0 80px;
            opacity: 0.2;
            /* scale: 120% 1; */
        }
    
        100% {
            translate: 0 0;
            opacity: 1;
            /* scale: 100% 1; */
        }
    }
    </style>
    